import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React from 'react';
import Button from '@/components/Button';
import DataButton from './DataButton';
import PreviewResolutionMenus from './PreviewResolutionMenus';
import useResolutionEditing from './useResolutionEditing';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ZoomInIcon = function ZoomInIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17C11.5723 17 13.0236 16.4816 14.1922 15.6064L19.2929 20.7071C19.6834 21.0976 20.3166 21.0976 20.7071 20.7071C21.0976 20.3166 21.0976 19.6834 20.7071 19.2929L15.6064 14.1922C16.4816 13.0236 17 11.5723 17 10C17 6.13401 13.866 3 10 3ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 7C9.44772 7 9 7.44772 9 8V9H8C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11H9V12C9 12.5523 9.44772 13 10 13C10.5523 13 11 12.5523 11 12V11H12C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9L11 9V8C11 7.44772 10.5523 7 10 7Z",
      fill: "#12131A"
    })]
  }));
};

ZoomInIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ZoomOutIcon = function ZoomOutIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17C11.5723 17 13.0236 16.4816 14.1922 15.6064L19.2929 20.7071C19.6834 21.0976 20.3166 21.0976 20.7071 20.7071C21.0976 20.3166 21.0976 19.6834 20.7071 19.2929L15.6064 14.1922C16.4816 13.0236 17 11.5723 17 10C17 6.13401 13.866 3 10 3ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12 9C12.5523 9 13 9.44772 13 10C13 10.5523 12.5523 11 12 11L8 11C7.44772 11 7 10.5523 7 10C7 9.44772 7.44772 9 8 9L12 9Z",
      fill: "#12131A"
    })]
  }));
};

ZoomOutIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const WidgetPreviewContainerLayoutControls = _ref => {
  let {
    className = '',
    zoomLevel,
    hasErrors,
    originFileType,
    previewResolution,
    activePreviewGroup,
    previewGroups,
    updatePreviewResolution,
    isDataButtonHidden = false,
    isResolutionControlHidden = false,
    isResolutionGroupControlHidden = false,
    isCustomResolutionControlHidden = false,
    isZoomControlHidden = false,
    updateActivePreviewGroup,
    adjustZoomLevel,
    onEditData,
    onEditDataErrors
  } = _ref;
  const {
    isCustomizingLayout,
    handlePreviewGroupChange,
    handleCustomResolutionChange,
    handlePreviewResolutionChange
  } = useResolutionEditing({
    previewResolution,
    activePreviewGroup,
    previewGroups,
    updatePreviewResolution,
    updateActivePreviewGroup
  });

  if (isResolutionGroupControlHidden && isZoomControlHidden && isDataButtonHidden) {
    return null;
  }

  return /*#__PURE__*/_jsxs("footer", {
    className: clsx(styles.container, className || ''),
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.container__left,
      children: [!isZoomControlHidden ? /*#__PURE__*/_jsx(ZoomControl, {
        zoomLevel: zoomLevel,
        adjustZoomLevel: adjustZoomLevel
      }) : /*#__PURE__*/_jsx(_Fragment, {}), !isResolutionGroupControlHidden ? /*#__PURE__*/_jsx(PreviewResolutionMenus, {
        isCustomizingLayout: isCustomizingLayout,
        previewResolution: previewResolution,
        activePreviewGroup: activePreviewGroup,
        previewGroups: previewGroups,
        isResolutionControlHidden: isResolutionControlHidden,
        isCustomResolutionControlHidden: isCustomResolutionControlHidden,
        handlePreviewGroupChange: handlePreviewGroupChange,
        handlePreviewResolutionChange: handlePreviewResolutionChange,
        handleCustomResolutionChange: handleCustomResolutionChange
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    }), onEditData && !isDataButtonHidden && /*#__PURE__*/_jsx("div", {
      className: clsx(styles.container__right, isResolutionGroupControlHidden && isResolutionControlHidden ? styles['container__right--hidden'] : ''),
      children: /*#__PURE__*/_jsx(DataButton, {
        hasErrors: hasErrors,
        originFileType: originFileType,
        onEditData: onEditData,
        onEditDataErrors: onEditDataErrors || onEditData
      })
    })]
  });
};

export default WidgetPreviewContainerLayoutControls;

const ZoomControl = _ref2 => {
  let {
    zoomLevel,
    adjustZoomLevel
  } = _ref2;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.zoomControl,
    children: [/*#__PURE__*/_jsx(Button, {
      className: styles.zoomControl__button,
      variant: "white",
      leftIcon: /*#__PURE__*/_jsx(ZoomOutIcon, {}),
      disabled: zoomLevel === 10,
      onClick: () => adjustZoomLevel(-10)
    }), /*#__PURE__*/_jsxs("span", {
      className: styles.zoomControl__indicator,
      children: [zoomLevel, "%"]
    }), /*#__PURE__*/_jsx(Button, {
      className: styles.zoomControl__button,
      variant: "white",
      leftIcon: /*#__PURE__*/_jsx(ZoomInIcon, {}),
      disabled: zoomLevel === 100,
      onClick: () => adjustZoomLevel(10)
    })]
  });
};